module.exports = __webpack_public_path__ + "img/student_bg.e8fbfd97.png";